import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const organizationsListTour: TourDefinition = {
  id: TOUR_IDS.ORGANIZATIONS_LIST,
  steps: [
    {
      target: '[data-tour="org-list-header"]',
      titleKey: 'organizationsList.welcome.title',
      contentKey: 'organizationsList.welcome.content',
      placement: 'bottom',
      skipBeacon: true,
    },
    {
      target: '[data-tour="create-organization-btn"]',
      titleKey: 'organizationsList.createOrg.title',
      contentKey: 'organizationsList.createOrg.content',
      placement: 'left',
    },
    {
      target: '[data-tour="org-search"]',
      titleKey: 'organizationsList.search.title',
      contentKey: 'organizationsList.search.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="org-card-grid"]',
      titleKey: 'organizationsList.orgCards.title',
      contentKey: 'organizationsList.orgCards.content',
      placement: 'top',
    },
  ],
};
